module.exports = __webpack_public_path__ + "images/start.882ad6555d473a0da444b1d3d09c6677.png";